var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDegree({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    "data-name": "025_SCIENCE",
    id: "_025_SCIENCE",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eefbf4;}")), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,14.44a1.07,1.07,0,0,1-.39-.07l-10-4.23A1,1,0,0,1,1,9.22a1,1,0,0,1,.61-.92l10-4.22a1,1,0,0,1,.78,0l10,4.22a1,1,0,0,1,.61.92,1,1,0,0,1-.61.92l-10,4.23A1.07,1.07,0,0,1,12,14.44ZM4.57,9.22,12,12.36l7.43-3.14L12,6.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,19.22c-4.49,0-8-2.08-8-4.75V10.79a1,1,0,0,1,2,0v3.68c0,1.3,2.57,2.75,6,2.75s6-1.45,6-2.75v-.65a1,1,0,0,1,2,0v.65C20,17.14,16.49,19.22,12,19.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,14.22a1,1,0,0,1-1-1v-4a1,1,0,1,1,2,0v4A1,1,0,0,1,22,14.22Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDegree);
export default __webpack_public_path__ + "static/media/degree.86882402d487112b18d8d2b3137152ac.svg";
export { ForwardRef as ReactComponent };